import _taggedTemplateLiteral from "/home/circleci/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n  color: var(", ");\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  ", "\n  ", "\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  display: inline-flex;\n  gap: var(\n    ", "\n  );\n  margin: 0;\n  padding: 0;\n\n  list-style: none;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  display: inline-block;\n  flex: 0 0 auto;\n\n  color: var(", ");\n\n  > button,\n  > a {\n    display: inline-block;\n    box-sizing: border-box;\n    min-width: 24px;\n    min-height: 24px;\n    margin: 0;\n    padding: 0;\n    padding-inline-start: var(", ");\n    padding-inline-end: var(", ");\n\n    color: inherit;\n    font: inherit;\n    text-align: center;\n    text-decoration: none;\n\n    background-color: transparent;\n    border: none;\n\n    transition: 150ms;\n    transition-timing-function: var(", ");\n    transition-property: color;\n\n    appearance: none;\n\n    &:hover {\n      cursor: pointer;\n    }\n\n    &[aria-disabled='true'] {\n      cursor: not-allowed;\n    }\n\n    &::after {\n      display: block;\n\n      border-bottom: 2px solid transparent;\n\n      content: '';\n    }\n  }\n\n  &:first-of-type > button {\n    padding-inline-start: 0;\n  }\n\n  &:last-of-type > button {\n    padding-inline-end: 0;\n  }\n\n  & [aria-current='page'] {\n    color: var(", ");\n\n    &::after {\n      border-color: var(\n        ", "\n      );\n    }\n  }\n\n  & [aria-disabled='true'] {\n    color: var(", ");\n  }\n\n  &:hover [aria-disabled='false'] {\n    color: var(", ");\n  }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  width: 0.5em;\n  height: 0.8125em;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  padding-inline-start: var(", ");\n  padding-inline-end: var(", ");\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n\n  width: 24px;\n\n  transform: scaleX(", ");\n\n  backface-visibility: hidden;\n\n  [dir='rtl'] & {\n    transform: scaleX(", ");\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled from 'styled-components';
import { injectSpacing } from '../../api/spacing/injectSpacing';
import { injectTypography } from '../../utils/injectTypography';
export var StyledIconContainer = styled.div(_templateObject(), function (props) {
  return props.prev ? -1 : 1;
}, function (props) {
  return props.next ? -1 : 1;
});
export var StyledCompactWrapper = styled.span(_templateObject2(), function (props) {
  return props.theme.responsive.spacing.xs;
}, function (props) {
  return props.theme.responsive.spacing.xs;
});
export var StyledArrow = styled.svg(_templateObject3());
export var StyledPaginationItem = styled.li(_templateObject4(), function (props) {
  return props.theme.colors.interaction.secondary.default;
}, function (props) {
  return props.theme.responsive.spacing.xs;
}, function (props) {
  return props.theme.responsive.spacing.xs;
}, function (props) {
  return props.theme.easing;
}, function (props) {
  return props.theme.colors.interaction.secondary.active;
}, function (props) {
  return props.theme.colors.interaction.secondary.active;
}, function (props) {
  return props.theme.colors.interaction.secondary.disabled;
}, function (props) {
  return props.theme.colors.interaction.secondary.hover;
});
export var StyledPagination = styled.ul(_templateObject5(), function (props) {
  return props.variant === 'minimalWithLabels' ? props.theme.responsive.spacing.l : props.theme.responsive.spacing.s;
});
export var StyledContainer = styled.nav(_templateObject6(), function (props) {
  return injectTypography(props, 'copy1');
}, injectSpacing('margin'));
export var StyledCurrentPage = styled.span(_templateObject7(), function (props) {
  return props.theme.colors.interaction.secondary.active;
});